import { Serializable } from '@/models/core/serializable';

export class SchoolGroupRespose implements Serializable<SchoolGroupRespose> {
  group: [];
  groupRuleID: number;
  groupType: number;
  growingPurpose: number;
  memo: string;
  name: string;
  tagIDs: number[];
  deserialize(input: any): SchoolGroupRespose {
    this.group = input.group;
    this.groupRuleID = input.groupRuleID;
    this.groupType = input.groupType;
    this.growingPurpose = input.growingPurpose;
    this.memo = input.memo;
    this.name = input.name;
    this.tagIDs = input.tagIDs;
    return this;
  }
}
